// Fetch list

export const FETCH = 'reportDriverPerformanceAnalysis.FETCH'
export const FETCH_STARTED = 'reportDriverPerformanceAnalysis.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportDriverPerformanceAnalysis.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportDriverPerformanceAnalysis.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportDriverPerformanceAnalysis.FETCH_CANCELLED'

// Clear

export const CLEAR = 'reportDriverPerformanceAnalysis.CLEAR'

// Export

export const EXPORT = 'reportDriverPerformanceAnalysis.EXPORT'
export const EXPORT_FULFILLED = 'reportDriverPerformanceAnalysis.EXPORT_FULFILLED'

// Fetch details

export const FETCH_DETAILS = 'reportDriverPerformanceAnalysis.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportDriverPerformanceAnalysis.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportDriverPerformanceAnalysis.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportDriverPerformanceAnalysis.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportDriverPerformanceAnalysis.FETCH_DETAILS_CANCELLED'

// Clear details

export const CLEAR_DETAILS = 'reportDriverPerformanceAnalysis.CLEAR_DETAILS'

// Export details

export const EXPORT_DETAILS = 'reportDriverPerformanceAnalysis.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportDriverPerformanceAnalysis.EXPORT_DETAILS_FULFILLED'
